import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface ImpersonationState {
  impersonatedUid: string | null;
  impersonatedName: string | null;
  impersonatedEmail: string | null;
  startImpersonation: (params: {
    uid: string;
    name: string;
    email: string;
  }) => void;
  stopImpersonation: () => void;
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      impersonatedUid: null,
      impersonatedName: null,
      impersonatedEmail: null,
      startImpersonation: ({ uid, name, email }) =>
        set({ impersonatedUid: uid, impersonatedName: name, impersonatedEmail: email }),
      stopImpersonation: () =>
        set({ impersonatedUid: null, impersonatedName: null, impersonatedEmail: null }),
    }),
    {
      name: "impersonation",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
